import React, { useContext } from "react";
import { IntlContext } from "context";
import { Badge } from "components/ui/badge";
import { BookOpen, Hammer, Home, ShieldCheck, Sprout, WandSparkles } from "lucide-react";

type CategoryPalette = "violet" | "pink" | "blue" | "amber" | "green" | "teal";

const CATEGORY_STYLE: Record<string, { icon: React.ReactNode; palette: CategoryPalette }> = {
    housekeeping: { icon: <WandSparkles className="h-3.5 w-3.5" />, palette: "violet" },
    childcare: { icon: <Home className="h-3.5 w-3.5" />, palette: "pink" },
    assistance: { icon: <ShieldCheck className="h-3.5 w-3.5" />, palette: "blue" },
    handiwork: { icon: <Hammer className="h-3.5 w-3.5" />, palette: "amber" },
    gardening: { icon: <Sprout className="h-3.5 w-3.5" />, palette: "green" },
    private_tutoring: { icon: <BookOpen className="h-3.5 w-3.5" />, palette: "teal" },
};

type Props = {
    category: string;
    label: string;
    isSubcategory?: boolean;
};

export const AdCategoryBadge: React.FC<Props> = ({ category, label, isSubcategory = false }) => {
    const intl = useContext(IntlContext);
    const catStyle = CATEGORY_STYLE[category.toLowerCase()];

    if (!catStyle) return null;

    const textLabel = isSubcategory
        ? intl.formatMessage(`service.label.subcategory.${label}`)
        : intl.formatMessage(`category.${label.toLowerCase()}`);

    return (
        <Badge variant="category" className="rounded-lg font-bold py-2 w-fit" palette={catStyle.palette}>
            {catStyle.icon}
            {textLabel}
        </Badge>
    );
};
